import React, { useState, useEffect } from 'react';
import {  Button, Form, Card, Input, Modal, Affix, List, Tag, Upload, message, Select, Spin, Row, Col, Table } from 'antd';
import { UploadOutlined, FileTextOutlined } from '@ant-design/icons';
import { useQuill } from "react-quilljs";
import 'react-quill/dist/quill.snow.css';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import Cookies from 'js-cookie';
import Quill from 'quill';
import QuillBetterTable from "quill-better-table";
import "quill-better-table/dist/quill-better-table.css";

Quill.register('modules/better-table', QuillBetterTable);

const EmailDrawer = ({ visible, onClose, objectName, recordId, fetchActivityRecords, template, attachments }) => {
  const currentUserId = Cookies.get('userId');
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false); // Add loading state
  const { quill, quillRef } = useQuill({
    modules: {
      table: false, // Disable default table module
      'better-table': {
        operationMenu: {
          items: {
            insertColumnRight: { text: 'Insert column right' },
            insertColumnLeft: { text: 'Insert column left' },
            insertRowUp: { text: 'Insert row above' },
            insertRowDown: { text: 'Insert row below' },
            deleteColumn: { text: 'Delete column' },
            deleteRow: { text: 'Delete row' },
            deleteTable: { text: 'Delete table' },
          },
        },
      },
      keyboard: {
        bindings: QuillBetterTable.keyboardBindings,
      },
    },
  });
  
  const [body, setBody] = useState('');
  const [templates, setTemplates] = useState([]);
  const [templateModalVisible, setTemplateModalVisible] = useState(false);
  const [toEmails, setToEmails] = useState([]);
  const [ccEmails, setCcEmails] = useState([]);
  const [bccEmails, setBccEmails] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [toEmailInput, setToEmailInput] = useState('');
  const [ccEmailInput, setCcEmailInput] = useState('');
  const [bccEmailInput, setBccEmailInput] = useState('');
  const [fromEmail, setFromEmail] = useState('');
  const [userEmails, setUserEmails] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (attachments && attachments.length > 0) {
      const formattedFiles = attachments.map((file, index) => ({
        uid: String(index), // Ensure a unique identifier
        name: "invoice.docx",
        status: "done", // Set status to 'done' to show as uploaded
        base64: `data:${file.type};base64,${file.content}`, // Convert back to Base64 format
        type: file.type,
      }));
      setFileList(formattedFiles);
    }
  }, [attachments]); // Run when attachments prop changes


  useEffect(() => {
    if (quill) {
      quill.on('text-change', handleBodyChange);
      
    }
  }, [quill]);

  const handleBodyChange = () => {
    if (quill) setBody(quill.root.innerHTML);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

    useEffect(() => {
  }, [fileList]);

  const fetchUsers = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/fetch_records/User`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
  
      if (response?.records && Array.isArray(response?.records)) {
        const currentUser = response?.records.find(user => user._id === currentUserId);
        if (currentUser) {
          setTags(currentUser.name);
          setFromEmail(currentUser.email);
          form.setFieldsValue({ from: currentUser.email });
        }
        const emailList = response?.records?.map(user => user.email);
        setUserEmails(emailList);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const emailListValidation = (_, value) => {
    if (!value) return Promise.resolve();
    const emails = value.split(',').map(email => email.trim());
    const isValid = emails.every(email =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    );
    return isValid
      ? Promise.resolve()
      : Promise.reject(new Error('Please enter valid email addresses.'));
  };

  useEffect(() => {
    fetchEmailTemplate();
  }, []);

  const fetchEmailTemplate = async () => {
    try {
      const apiServiceForEmail = new ApiService(
        `${BASE_URL}/get_all_template`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiServiceForEmail.makeCall();

      setTemplates(response);


    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (template) {
      handleTemplateSelect(template);
    }
  }, [template]);

  useEffect(() => {
    if (template && quill) {
      setTimeout(() => {
        quill.clipboard.dangerouslyPasteHTML(template.body);
        setBody(template.body);
      }, 100);
    }
  }, [template, quill]);
  

  const handleTemplateSelect = (template) => {


    form.setFieldsValue({
      subject: template.subject,
    });

    if (quill) {
      quill.root.innerHTML = template.body;
    }

    setBody(template.body);
    setTemplateModalVisible(false);
  };

  const handleEmailChange = (e, emailType) => {
    const email = e.target.value.trim();
    if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      switch (emailType) {
        case 'to':
          setToEmails(prevEmails => [...prevEmails, email]); 
          setToEmailInput(''); // Clear the input after adding email
          break;
        case 'cc':
          setCcEmails(prevEmails => [...prevEmails, email]);
          setCcEmailInput(''); // Clear the input after adding email
          break;
        case 'bcc':
          setBccEmails(prevEmails => [...prevEmails, email]);
          setBccEmailInput(''); // Clear the input after adding email
          break;
        default:
          break;
      }
    }
  };

  const handleFileChange = ({ fileList: newFileList }) => {
    const toBase64 = file =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
  
   Promise.all(newFileList.map(file => toBase64(file.originFileObj || file)))
      .then(base64Files => {
      const updatedFileList = newFileList.map((file, index) => ({
        ...file,
        base64: base64Files[index], // Store Base64 string
        status: "done", // Ensure the upload status is complete
      }));

      setFileList(updatedFileList);
    })
      .catch(error => console.error('Base64 conversion error:', error));
  };


  const handleSave = async () => {
    try {
      // First, validate the form
      await form.validateFields();

      if (toEmails.length === 0) {
        message.error("Please add at least one recipient in the 'To' field.");
        return;
    }
  
    setLoading(true); // Start loading

      const emailData = {
        from: form.getFieldValue('from'),
        to: toEmails.join(','),
        cc: ccEmails,  // Sending as an array
        bcc: bccEmails,
        subject: form.getFieldValue('subject'),
        body_text: quill ? quill.root.innerText : '',  // plain text body from quill editor
        body_html: body,
        attachments: fileList.map(file => ({
          name: file.name,
          type: file.type,
          content: file.base64.split(',')[1], // Remove 'data:mime/type;base64,' prefix
        })),  // Collects the attached files
        inline_images: [],  // Add inline image paths if needed
        related_to: recordId,
        associated_object: objectName,
      };
      // Create the API service instance
      const apiServiceForEmail = new ApiService(
        `${BASE_URL}/send_email`,
        { 'Content-Type': 'application/json' },
        'POST',
        emailData
      );
  
      // Make the API call and handle response
      const response = await apiServiceForEmail.makeCall();
  
      // Check if the response is valid
      if (response && response.status === "success") {
        message.success('Email sent successfully!'); // Show success message
        onClose(); // Close the drawer after sending email
      form.resetFields(); // Reset the form
      fetchActivityRecords();
      setToEmails([]);
      setCcEmails([]);
      setBccEmails([]);
      setBody('');
      if (quill) {
        quill.root.innerHTML = ''; // Clear the editor HTML content
        quill.setText(''); // Also clear the editor text content
      }
      setFileList([]); // Clear file list
      } else {
        console.error('Failed to send email:', response);
        message.error('Failed to send email. Please try again.'); // Show error message
        // Handle error if the response is not successful
      }
  
    } catch (error) {
      console.error('Error Sending Email:', error);
      message.error('Failed to send email. Please try again.');

      // Handle form validation or API call error here (e.g., show error message)
    }
    finally {
      setLoading(false); // Stop loading
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "template_name",
      key: "name",
      render: (text, record) => (
        <a onClick={() => handleTemplateSelect(record)}>{text}</a>
      ),
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Object",
      dataIndex: "object_name",
      key: "object",
    },
  ];
  

  return (
    <>
    {loading && (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(255, 255, 255, 0.7)', // Light blur effect
        backdropFilter: 'blur(5px)', // Apply blur
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999 // Ensure it appears above everything
      }}>
        <Spin size="large" />
      </div>
    )}
    

    <Modal
      title={<div style={{ fontSize: '20px', fontWeight: 'bold' }}>{'Send Email'}</div>}
      width="70%"
      placement="right"
      zIndex={1002}   // higher than sidebar
      onCancel={onClose}
      visible={visible}
      closable={true}
      bodyStyle={{ paddingBottom: 80, maxHeight: '70vh', overflowY: 'auto' }}  
      headerStyle={{
        padding: '20px 16px',
        background: '#f0f2f5',
        borderBottom: '1px solid #e8e8e8',
      }}
      footer={  
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: "sticky",
          bottom: 0,
          background: 'none', 
          padding: "10px 0",
          textAlign: "center",

        }}
      >
        <Button onClick={onClose} style={{ height: '34px', width: '90px', fontSize: '14px' }}>
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={handleSave}
          loading={loading} 
          disabled={loading}
          style={{
            height: '34px',
            width: '90px',
            fontSize: '14px',
            border: '1px solid #1890ff',
          }}
        >
          {loading ? 'Sending...' : 'Send'}
        </Button>
      </div>
      }
    >
      <Card style={{ margin: '10px', padding: '10px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
        <Form form={form} layout="vertical">

        <Form.Item
            label="From"
            name="from"
          >
            <Input value={fromEmail} disabled />
          </Form.Item>

        <Form.Item
            label="To"
            name="to"
          >
            <Input
              placeholder="Enter recipient's email (Press enter to add multiple emails)"
              value={toEmailInput} // Use the separate state for 'To'
              onChange={(e) => setToEmailInput(e.target.value)} // Update 'To' input state
              onPressEnter={(e) => handleEmailChange(e, 'to')}
            />
            <div style={{ marginTop: 10 }}>
            {toEmails.map((email) => (
              <Tag
                key={email}
                closable
                onClose={() => setToEmails((prev) => prev.filter((item) => item !== email))}
              >
                {email}
              </Tag>
            ))}
            </div>

          </Form.Item>

          <Form.Item label="CC" name="cc" rules={[{ validator: emailListValidation }]}>
            <Input
              placeholder="Enter CC email (Press enter to add multiple emails)"
              value={ccEmailInput} // Use the separate state for 'CC'
              onChange={(e) => setCcEmailInput(e.target.value)} // Update 'CC' input state
              onPressEnter={(e) => handleEmailChange(e, 'cc')}
            />
             <div style={{ marginTop: 10 }}>
              {ccEmails.map((email) => (
                <Tag
                  key={email}
                  closable
                  onClose={() => setCcEmails((prev) => prev.filter((item) => item !== email))}
                >
                  {email}
                </Tag>
              ))}
            </div>
          </Form.Item>

          <Form.Item label="BCC" name="bcc" rules={[{ validator: emailListValidation }]}>
            <Input
              placeholder="Enter BCC email (Press enter to add multiple emails)"
              value={bccEmailInput} // Use the separate state for 'BCC'
              onChange={(e) => setBccEmailInput(e.target.value)} // Update 'BCC' input state
              onPressEnter={(e) => handleEmailChange(e, 'bcc')}
            />
           <div style={{ marginTop: 10 }}>
              {bccEmails.map((email) => (
                <Tag
                  key={email}
                  closable
                  onClose={() => setBccEmails((prev) => prev.filter((item) => item !== email))}
                >
                  {email}
                </Tag>
              ))}
            </div>
          </Form.Item>
      
          <Form.Item
            label="Subject"
            name="subject"
            rules={[{ required: true, message: 'Please enter the email subject.' }]}
          >
            <Input placeholder="Enter email subject" />
          </Form.Item>

          <Form.Item label="Body">
            <div style={{ width: "100%", height: 200 }}>
              <div ref={quillRef} onChange={handleBodyChange} />
            </div>
          </Form.Item>

          <Form.Item>
           {/* Buttons for Attach Files and Insert Template */}
           <div style={{ display: 'flex', gap: '10px', marginTop: '50px' }}>
           <Upload
                multiple
                onChange={handleFileChange}
                fileList={fileList}
                showUploadList={{ showRemoveIcon: true }}
              >
                <Button icon={<UploadOutlined />} size="middle" >
                  Attach Files
                </Button>
              </Upload>
            <Button icon={<FileTextOutlined />} size="middle" onClick={() => setTemplateModalVisible(true)}>
              Insert Template
            </Button>
          </div>
          </Form.Item>
        </Form>
      </Card>

      {/* Template Selection Modal */}
      <Modal
      title="Insert Email Template"
      visible={templateModalVisible}
      onCancel={() => setTemplateModalVisible(false)}
      footer={null}
      width={800}
      zIndex={1002}   // higher than sidebar
      bodyStyle={{ maxHeight: "500px", overflowY: "auto" }}
    >

      <Table
        columns={columns}
        dataSource={templates}
        pagination={false}
        scroll={{ y: 300 }}
      />

      <Row justify="end" style={{ marginTop: 16 }}>
        <Button onClick={() => setTemplateModalVisible(false)}>Cancel</Button>
      </Row>
    </Modal>  
    </Modal>
    </>
  );
};

export default EmailDrawer;
